import { msTeamsColor, zoomColor } from 'athena/styles/colors';
import {
  ExternalSession,
  IntegrationTypes,
  SessionTypes,
} from './live-event';
import { MentoringProgramActionItem } from './mentoring-program-action-items';
import { MentorshipProgramConnection } from './mentorship-program-connections';

export enum IntegrationType {
  ZOOM = 'Zoom',
  MS_TEAMS = 'MS Teams',
}

export enum Cadence {
  WEEKLY = 'weekly',
  BI_WEEKLY = 'bi_weekly',
  MONTHLY = 'monthly',
  DEFAULT = '',
}

type AuthenticatedUser = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  accountEmail: string;
};

type CreatedLiveSessions = {
  hasCreatedLiveSessions: boolean | null;
  redirectLiveSessionUrl: string | null;
};

export type OauthIntegration = {
  authenticatedStatus: AuthenticationStatus;
  recordingScope: boolean;
  authenticationEmail: string;
  createdLiveSessions: CreatedLiveSessions;
  authenticatedUser: AuthenticatedUser;
};

export type IntegrationAuth = {
  source: IntegrationTypes[];
  microsoftGraphOauth: OauthIntegration;
  zoomOauth: Partial<OauthIntegration>;
  zoomAccountOauth: Partial<OauthIntegration>;
};


export type MentorshipProgramMeetingPlan = {
  id: number;
  title: string;
  details?: string;
  startDate: string | moment.Moment;
  mentorshipProgramSessions: MentorshipProgramSession[];
  location?: string;
  duration?: number;
  cadence: Cadence;
  endDate?: string | moment.Moment;
  joinUrl?: string;
  sessionType?: SessionTypes;
  isLoading?: boolean;
};

export enum NextStepKey {
  CREATE_MEETING_PLAN = 'waitingPlanSession', // Returned by Connections API
  SESSION_PULSE_CHECK = 'sessionPulseCheck',
  PROGRAM_REFLECTION = 'programReflection',
}

export enum SessionFilters {
  PAST = 'past',
  UPCOMING = 'upcoming',
}

export type PulseCheckQuestion = {
  id: number;
  questionText: string;
  questionIndex: number;
};

export type PulseCheckResponse = {
  questionId: number;
  response: string | number;
};

export type PulseCheckResponses = {
  [enrollmentId: string]: PulseCheckResponse[];
};

export type ConversationStarterCategory = 'explore' | 'connect' | 'challenge';

export type ConversationStarter = {
  category: ConversationStarterCategory;
  conversationStarter: string;
};

export type MentorshipProgramSession = {
  id: number;
  title: string;
  details?: string;
  // consider checking with backend to change this
  status: 'past' | 'upcoming';
  scheduledDate: string | moment.Moment;
  mentorshipProgramConnection: MentorshipProgramConnection;
  mentorshipProgramActionItems: MentoringProgramActionItem[];
  pulseCheckQuestions: PulseCheckQuestion[];
  pulseCheckResponses: PulseCheckResponses;
  location?: string;
  duration?: number; // in minutes
  mentorshipProgramSessionPlanId?: number;
  joinUrl?: string;
  sessionType?: SessionTypes;
  liveSession?: ExternalSession[];
  cadence?: Cadence;
  endsOn?: string | moment.Moment;
  preparationNote?: string | null;
  conversationStarters?: ConversationStarter[];
};

export const ALL_INTEGRATION_TYPES = 'ALL';

export enum AuthenticationStatus {
  NOT_CONFIGURED = 'not_configured',
  AUTHENTICATED = 'authenticated',
  NOT_AUTHENTICATED = 'not_authenticated',
}

export const mappingIntegrationType = {
  [SessionTypes.MS_TEAMS]: 'microsoft_graph_oauth',
  [SessionTypes.ZOOM]: 'zoom_oauth',
  [SessionTypes.MS_CALENDAR]: 'microsoft_graph_calendar_oauth',
};

export const sessionTypeOptions = {
  [SessionTypes.MS_TEAMS]: {
    id: SessionTypes.MS_TEAMS,
    img: 'images/msteam-blue.svg',
    color: msTeamsColor,
  },
  [SessionTypes.ZOOM]: {
    id: SessionTypes.ZOOM,
    img: 'images/zm.svg',
    color: zoomColor,
  },
};

export const translationIntegrationKeys = {
  [SessionTypes.MS_TEAMS]: 'MS_TEAMS',
  [SessionTypes.ZOOM]: 'ZOOM',
  [SessionTypes.MS_CALENDAR]: 'MS_CALENDAR',
  ALL: 'ALL',
};
